import type { TFunction } from "i18next";

/** User-facing label for a library link-ingest failure code (never raw enum strings). */
export function libraryLinkFailureLabel(
  failureReason: string | null | undefined,
  t: TFunction<"app">,
): string {
  if (!failureReason) {
    return t("library.statusRejected");
  }
  if (failureReason === "invalid_url") {
    return t("library.linkIngestInvalidUrl");
  }
  if (failureReason === "ssrf_blocked") {
    return t("library.linkIngestBlockedUrl");
  }
  return t("library.statusRejectedReason", { reason: failureReason });
}
